import { NgClass } from '@angular/common'
import { Component, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { ClickOutsideDirective } from '../../../../../shared/directives/click-outside.directive'
import type { YearChip } from '../../../../../types/types'

@Component({
  selector: 'dhp-year-filter-dialog',
  templateUrl: './year-filter-dialog.component.html',
  styleUrls: ['./year-filter-dialog.component.scss'],
  imports: [ClickOutsideDirective, NgClass, TranslatePipe],
})
export class YearFilterDialogComponent {
  readonly isOpen = input(false)
  readonly years = input<YearChip[]>([])
  readonly yearSelected = input<YearChip | null>(null)

  readonly isOpenChange = output<boolean>()
  readonly yearSelectedChange = output<YearChip | null>()
  readonly earlierEditionsClicked = output()

  closeDialog(): void {
    this.isOpenChange.emit(false)
  }

  selectYear(year: YearChip): void {
    if (
      year &&
      typeof year === 'object' &&
      'label' in year &&
      'value' in year &&
      'count' in year
    ) {
      this.yearSelectedChange.emit(year)
    }
    this.closeDialog()
  }

  showEarlierEditions(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.earlierEditionsClicked.emit()
    this.closeDialog()
  }
}
